import { Grid } from "@mui/material";

import { TipoReferidoEnumChoice, gridSizeMdLg6 } from "@/shared";
import { CustomTextFieldNoForm, TabTextLabel } from "@/shared/components/ui";
import { CustomAlertCard } from "@/shared/components/ui/Alerts";
import { Cliente } from "@/shared/interfaces";
import { Flota } from "@/shared/interfaces/erp/mantenimiento-operaciones";

export type ReferidoDataComponentPreventaProps = {
  tipoReferido: string;
  referido_flota_data?: Flota;
  referido_cliente_data?: Cliente;

  showTitle?: boolean;
};

const ReferidoDataComponentPreventa: React.FC<
  ReferidoDataComponentPreventaProps
> = ({
  tipoReferido,
  referido_flota_data,
  referido_cliente_data,
  showTitle = true,
}) => {
  if (!tipoReferido) {
    return (
      <CustomAlertCard
        alertTitle="Información de Referido"
        alertMessage={"Este cliente no ingresó bajo sistema de referidos."}
      />
    );
  }

  return (
    <>
      {showTitle && (
        <Grid item xs={12}>
          <TabTextLabel text="Información de Referido" />
        </Grid>
      )}

      <CustomTextFieldNoForm
        label="Tipo referido"
        value={tipoReferido || ""}
        disabled
        size={gridSizeMdLg6}
      />

      {tipoReferido === TipoReferidoEnumChoice.CLIENTE ? (
        <>
          <CustomTextFieldNoForm
            label="Cliente refiere"
            value={referido_cliente_data?.razon_social || ""}
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="Cédula cliente refiere"
            value={referido_cliente_data?.identificacion || ""}
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="Celular cliente refiere"
            value={referido_cliente_data?.celular || ""}
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="Dirección cliente refiere"
            value={referido_cliente_data?.direccion || ""}
            disabled
          />
        </>
      ) : tipoReferido === TipoReferidoEnumChoice.EMPLEADO ? (
        <>
          NO
          {/* <CustomTextFieldNoForm
            label="Empleado refiere"
            defaultValue={preventa?.empleado_refiere || ''}
            value={preventa?.empleado_refiere || ''}
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="Cédula empleado refiere"
            defaultValue={preventa?.cedula_empleado_refiere || ''}
            value={preventa?.cedula_empleado_refiere || ''}
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="Celular empleado refiere"
            defaultValue={preventa?.telefono_empleado_refiere || ''}
            value={preventa?.telefono_empleado_refiere || ''}
            disabled
            size={gridSizeMdLg6}
          /> */}
        </>
      ) : tipoReferido === TipoReferidoEnumChoice.FLOTA ? (
        <>
          <CustomTextFieldNoForm
            label="Flota refiere"
            value={referido_flota_data?.nombre || ""}
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="Lider flota refiere"
            value={referido_flota_data?.lider || ""}
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="Teléfono flota refiere"
            value={referido_flota_data?.telefono_1 || ""}
            disabled
            size={gridSizeMdLg6}
          />
        </>
      ) : null}
    </>
  );
};

export default ReferidoDataComponentPreventa;
